import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { upgradeRequest } from '../../actions/signup'

// Utils
import { translation } from '../../utils/helpers'
// import { hasSubscriptionPermission } from '../../utils/auth'

// import styles
import './dashboard.scss'

// import components
import Header from '../../shared/components/Header'

class Dashboard extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Name: '',
      Phone: '',
      IsValid: false,
      RequestSent: false
    }
    this.onClickContactMe = this.onClickContactMe.bind(this)
    this.updateState = this.updateState.bind(this)
    this.upgradeRequest = this.upgradeRequest.bind(this)
  }

  componentWillMount () {
    if (this.props.auth.permissions.ShopSubscriptionType === undefined || this.props.auth.permissions.ShopSubscriptionType !== 1) {
      if (this.props.auth.user.ShopSubscriptionType === undefined || this.props.auth.user.ShopSubscriptionType !== 1) {
        setTimeout(() => {
          // console.log(this.props.auth.user)
          if (this.props.auth.user.CustomerId !== undefined && this.props.auth.user.CustomerId !== '-1') {
            this.props.router.push('/orders')
            return
          } else {
            if (this.props.auth.user.UserType === 8) {
              this.props.router.push('/selectshop')
              return
            } else if (this.props.auth.user.UserType === 1) {
              this.props.router.push('/chains')
              return
            } else if (this.props.auth.user.UserType === 6) {
              this.props.router.push('/orders')
              return
            } else if (this.props.auth.user.UserType !== undefined) {
              console.log('go to workscreen', this.props.auth.user.UserType)
              this.props.router.push('/workscreen')
              return
            }
          }
        }, 200)
      }
    }
  }
  componentDidMount () {
    // console.log('Props ', this.props)
    this.updateState(this.props.auth.user.ContactName, this.props.auth.user.ContactPhone)
    // console.log('is new user', this.props.auth.user.IsNewUser)
  }

  upgradeRequest (name, phone, userId) {
    this.props.upgradeRequest(name, phone, userId).then((res) => {
      this.setState({
        RequestSent: true
      })
    })
  }

  onClickContactMe (e) {
    e.preventDefault()
    if (this.state.Name !== '' && this.state.Phone !== '') {
      this.upgradeRequest(this.state.Name, this.state.Phone, this.props.auth.user.UserId)
    }
  }

  updateState (name, phone) {
    let valid = name !== '' && name !== null && phone !== '' && phone !== null
    this.setState({
      Name: name,
      Phone: phone,
      IsValid: valid
    }, () => {
    })
  }

  render () {
    if (this.props.auth.permissions.ShopSubscriptionType === undefined || this.props.auth.permissions.ShopSubscriptionType !== 1) return null

    const onChange = (e) => {
      let name = this.state.Name
      let phone = this.state.Phone
      switch (e.target.name) {
        case 'name':
          name = e.target.value
          break
        case 'phone':
          phone = e.target.value
          break
      }
      this.updateState(name, phone)
    }

    let isNewUser = this.props.auth.user.IsNewUser === true
    let showRequestBlock = !this.state.RequestSent

    return (
      <div className='dashboard__screen'>
        <Header router={this.props.router} title='Dashboard' />
        <div className='content'>
          {isNewUser && (
            <div className='header_text'>{translation('2134')}</div>
          )}
          <div className='block_container'>
            {!showRequestBlock && (
              <div className='info_block'>
                <img className='image' src='/images/icons/Apromas-free200x200px.png' />
                <div className='info'>
                  <div className='block_header'>{translation('2141')}</div>
                  <p>{translation('2133')}</p>
                </div>
              </div>
            ) || (
              <div className='info_block'>
                <img className='image' src='/images/icons/Apromas-free200x200px.png' />
                <div className='info'>
                  <div className='block_header'>{translation('2138')}</div>
                  <p>{translation('2139')}</p>
                  <p>{translation('2122')} <a href='http://apromas.com/da/produkt'>{translation('2123')}</a></p>
                  <form>
                    <p>{translation('2137')}</p>
                    <div>
                      <input type='text' name='name' onChange={onChange} value={this.state.Name} />
                      <label htmlFor='name'>{translation('30')}</label>
                    </div>
                    <div>
                      <input type='text' name='phone' onChange={onChange} value={this.state.Phone} />
                      <label htmlFor='phone'>{translation('38')}</label>
                    </div>
                    <button onClick={this.onClickContactMe} disabled={!this.state.IsValid}>{translation('2140')}</button>
                  </form>
                </div>
              </div>
            )}

            <div className='info_block'>
              <img className='image' src='/images/icons/Apromas-support200x200px.png' />
              <div className='info'>
                <div className='block_header'>{translation('2135')}</div>
                <p>{translation('2136')} <a href='http://apromas.com/da/support'>{translation('2123')}</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

Dashboard.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  upgradeRequest
})(Dashboard)



// WEBPACK FOOTER //
// ./src/app/pages/Dashboard/index.js